import styled from 'styled-components';
import 'react-photo-view/dist/react-photo-view.css';

export const Item = styled.span`
  display: contents;
  cursor: zoom-in;
`;
